import script from "./author.vue?vue&type=script&setup=true&lang=js"
export * from "./author.vue?vue&type=script&setup=true&lang=js"

import "./author.vue?vue&type=style&index=0&id=b0d4da48&lang=css"

const __exports__ = script;

export default __exports__